module.exports = __webpack_public_path__ + "img/you.7032c235.png";